import { format } from "date-fns/esm";
import React from "react";

const BookingModal = ({ modalInfo, selectedDate,setModalInfo }) => {
  const { name, slots } = modalInfo;
  const date = format(selectedDate, "PP");

const handleBooking=(event)=>{
event.preventDefault()
const form = event.target;
const slot = form.slot.value;
const fullName = form.fullName.value;
const email = form.email.value;
const phone = form.number.value;

const booking = {
    appointmentDate: date,
    slot,
    service: name,
    fullName,
    email,
    phone
}
setModalInfo(null)
console.log(booking )


}


  return (
    <div>
      <input type="checkbox" id="booking-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="booking-modal"
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 className="text-lg font-bold">{name}</h3>

          <form onSubmit={handleBooking} className="grid gap-6 grid-cols-1 mt-8">
            <input
              type="text"
              name="date"
              value={date}
              disabled
              className="input input-bordered  w-full "
            />
            <select name="slot" className="select select-bordered w-full ">
              
             {
                slots.map((slot,i)=><option value={slot} key={i}>{slot}</option>)
             }
              
            </select>
            <input
              type="text"
            name="fullName"
              placeholder="Enter your Full Name"
              className="input input-bordered  w-full "
            />
            <input
              type="email"
              name="email"
              placeholder="Enter your Email"
              className="input input-bordered  w-full "
            />
            <input
              type="number"
             name="number"
              placeholder="Enter your Phone Number"
              className="input input-bordered  w-full "
              required
            />
            <input  className="btn btn-accent text-white" type="submit" value="Submit" />
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
